// open the cart drawer 
function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  variantSelection();
}

// close the cart drawer 
function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
}

//  use for remove Function count
async function updateCartItemCount(count = 0){
  // ajax update
  const res = await fetch('/cart',{
    method: "get",
    headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        }
  });
  const cart =  await res.json();
  console.log(cart)
  if(count != 0){
    document.querySelectorAll('.cart-count-bubble').forEach(el =>{
      el.textContent = count;
    })
  }else{
    document.querySelectorAll('.cart-count-bubble').forEach(el =>{
      el.textContent = cart.item_count;
    })
  }  
}


// update the cart count items
function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}

// update the cart drawer 
async function updateCartDrawer() {
  const aks_res = await fetch("/?snippet_id=cart-drawer");
  const aks_text = await aks_res.text();
  const aks_div = document.createElement("aks_div");
  aks_div.innerHTML = aks_text;
  const aks_newBox = aks_div.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = aks_newBox;
  addCartDrawerListeners();
  removeCartDrawerListeners();
  addCartUpsellListeners();
  variantSelection();
}
addCartDrawerListeners();
removeCartDrawerListeners();
  addCartUpsellListeners();

//
document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
// to stop another function trigger
   e.preventDefault();
    
    // Submit form with ajax
      await fetch("/cart/add", {
      method: "post",
      body: new FormData(form),
    });

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();
    
// funtion call for cart drawer open
openCartDrawer();
  });
});


// update plus minus => quantity in the cart
function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem = button.parentElement.parentElement.parentElement.parentElement.parentElement;
        const key = rootItem.getAttribute("data-line-item-key");
        // Get new quantity
        const currentQuantity = Number(button.parentElement.querySelector("input").value);
        const isUp = button.classList.contains("cart-drawer-quantity-selector-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        // Update cart
        updateCartDrawer();
      });
    });
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  document.querySelectorAll(".cart-drawer-header-right-close, .cart-drawer").forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });
}



// funtion call for cart drawer close 
  document.querySelectorAll(".cart-drawer-header-right-close")
    .forEach((el) => {
      el.addEventListener("click", () => {
        console.log("closing drawer");
        closeCartDrawer();
      });
    });





//open cart drawer on click at cart icon
document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});




// remove product from cart
function removeCartDrawerListeners() {
   // update Quantities
 document.querySelectorAll('.aks_product_remove button').forEach((button) => {
   button.addEventListener("click", async (e) =>{
     e.preventDefault();
     // Get line item key
    const rootitem = button.parentElement.parentElement.parentElement.parentElement.parentElement;
     console.log(rootitem);
     const key = rootitem.getAttribute("data-line-item-key");
   // Get new quantity
   
     const newquanity = 0;
     
   // ajax update
    const res = await fetch('/cart/update.js',{
      method: "post",
      headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newquanity } }),
    });
     const cart =  await res.json();
     updateCartItemCount(cart.item_count);
   // update cart
     updateCartDrawer();
   });
   
 });
}



//upsell Add button  function 

function variantSelection(){
  document.querySelectorAll('.f-upsale-main select').forEach(select => {
    select.addEventListener('change',()=>{
      let parentDiv = select.closest('.f-upsale-main')
      let btn = parentDiv.querySelector('.f-upsale-add')
      btn.setAttribute('data-variant-id',select.value);
    })
  })
}


// upsale function
function addCartUpsellListeners() {
   // update Quantities
 document.querySelectorAll('.add.f-upsale-add').forEach((button) => {
   button.addEventListener("click", async (e) =>{
    e.preventDefault()
     // Get line item key
     
     const key = button.getAttribute("data-variant-id");
   // Get new quantity
    
     const newquanity = 1;
     
   // ajax update
    const res = await fetch('/cart/update.js',{
      method: "post",
      headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newquanity } }),
    });
     const cart =  await res.json();
     updateCartItemCount(cart.item_count);
   // update cart
     updateCartDrawer();
   });
 });   
 };